import React, { FC, PropsWithChildren, useState } from 'react';
import { IPaymentSubmissionsContext } from '../../models/paymentSubmissions';
import { getAllPaymentSubmissions } from './get-all-payment-submissions';
import { savePaymentSubmissionWithProgress } from './save-payment-submission-with-progress';
import {
  ExpenseSubmitData,
  PaymentConfigCategory,
  PaymentConfigSubcategory,
} from '../../models/paymentConfig';
import { getAllReclaimRewards } from './get-all-bucketed-rewards';

export const PaymentSubmissionContext =
  React.createContext<IPaymentSubmissionsContext | null>(null);

export const PaymentSubmissionContextProvider: FC<PropsWithChildren> = (
  props
) => {
  const [selectedPaymentCategory, _setSelectedPaymentCategory] =
    useState<PaymentConfigCategory | null>(null);
  const [selectedPaymentSubcategory, _setSelectedPaymentSubcategory] =
    useState<PaymentConfigSubcategory | null>(null);
  const [isSavingSubmission, setIsSavingSubmission] = useState(false);
  const [expenses, setExpenses] = useState<ExpenseSubmitData[]>([]);

  const setSelectedPaymentCategory = (value: PaymentConfigCategory | null) =>
    _setSelectedPaymentCategory(value);
  const setSelectedPaymentSubcategory = (
    value: PaymentConfigSubcategory | null
  ) => _setSelectedPaymentSubcategory(value);

  const resetExpenses = () => {
    setExpenses([]);
  };

  const addExpense = (expense: ExpenseSubmitData) => {
    setExpenses([...expenses, expense]);
  };

  return (
    <PaymentSubmissionContext.Provider
      value={{
        isSavingSubmission,
        expenses,
        selectedPaymentCategory,
        selectedPaymentSubcategory,
        setIsSavingSubmission,
        save: savePaymentSubmissionWithProgress,
        getAll: getAllPaymentSubmissions,
        addExpense,
        resetExpenses,
        setSelectedPaymentCategory,
        setSelectedPaymentSubcategory,
        getAllReclaimRewards,
      }}
      {...props}
    />
  );
};

export const usePaymentSubmissionsContext = (): IPaymentSubmissionsContext => {
  const context = React.useContext(PaymentSubmissionContext);
  if (!context) {
    throw new Error(
      'usePaymentSubmissionsContext must be used within a PaymentSubmissionContextProvider'
    );
  }
  return context;
};
